import { Route, Routes } from "react-router-dom";
import { PreenchimentoATPV } from "../Pages/PreenchimentoATPV";
import { PreenchimentoATPVDetalhes } from "../Pages/PreenchimentoATPVDetalhes";
import { AutorizacaoPlaca } from "../Pages/AutorizacaoPlaca";
import { AutorizacaoPlacaPage } from "../Pages/AutorizacaoPlaca/context/AutorizacaoPlacaContext";
import { GerenciarEmplacamentos } from "../Pages/GerenciarEmplacamentos";
import { ExtracaoXml } from "../Pages/ExtracaoXml";
import { ExtracaoAtpv } from "../Pages/ExtracaoAtpv";
import { Licenciamento } from "../Pages/Licenciamento";
import { DetalhesLicenciamento } from "../Pages/Licenciamento/DetalhesLicenciamento";
import { ImpressaoEtiqueta } from "../Pages/ImpressaoEtiqueta";
import { LoteEstampagem } from "../Pages/LoteEstampagem";
import { GerenciarLote } from "../Pages/LoteEstampagem/pages/GerenciarLote";
import { SolicitacaoPlaca } from "../Pages/SolicitacaoPlaca";
import { VisualizarLote } from "../Pages/SolicitacaoPlaca/pages/VisualizarLote";
import { PlacaTerceiros } from "../Pages/PlacaTerceiros";
import { GerenciarEmplacamentosInformeFaturamento } from "../Pages/GerenciarEmplacamentosInformeFaturamento";
import { InformeFaturamentoProvider } from "../Pages/GerenciarEmplacamentosInformeFaturamento/context/InformeFaturamentoContext";

function BackofficeRoutes() {
  return (
    <Routes>
      <Route path="/extracaoxml" element={<ExtracaoXml />} />
      <Route path="/preenchimentoatpv" element={<PreenchimentoATPV />} />
      <Route
        path="/preenchimentoatpv/detalhes"
        element={<PreenchimentoATPVDetalhes />}
      />
      <Route
        path="/autorizaPlaca"
        element={
          <AutorizacaoPlacaPage>
            <AutorizacaoPlaca />
          </AutorizacaoPlacaPage>
        }
      />
      <Route
        path="/gerenciaremplacamento"
        element={<GerenciarEmplacamentos />}
      />
      <Route
        path="/gerenciarEmplacamentosInformeFaturamento"
        element={
          <InformeFaturamentoProvider>
            <GerenciarEmplacamentosInformeFaturamento />
          </InformeFaturamentoProvider>
        }
      />
      <Route path="/extracaoatpv" element={<ExtracaoAtpv />} />
      <Route path="/licenciamento" element={<Licenciamento />} />
      <Route path="/licenciamento/detalhes" element={<DetalhesLicenciamento />} />
      <Route path="/impressao-etiqueta" element={<ImpressaoEtiqueta />} />
      <Route path="/estampagem-placa" element={<LoteEstampagem />} />
      <Route path="/estampagem-placa/:id" element={<GerenciarLote />} />
      <Route path="/solicitacao-placa" element={<SolicitacaoPlaca />} />
      <Route path="/solicitacao-placa/:id" element={<VisualizarLote />} />
      <Route path="/placa-terceiros" element={<PlacaTerceiros />} />
    </Routes>
  );
}
export { BackofficeRoutes };
